<template>
    <select name="brick_variation" class="input w-full" :class="{ 'cursor-not-allowed': ! brick }" :required="required && brick">
        <option v-if="! brick" value="other-unlisted">No brick selected...</option>
        <option v-for="(variation, id) in options" :selected="id === selected" :key="id" :value="`${variation.height}x${variation.length}x${variation.depth}`" v-html="variation.display"></option>
        <option v-if="brick" value="standard" :selected="'standard' === selected">H 65mm x L 215mm x D 102.5mm (Standard)</option>
    </select>
</template>

<script>
export default {
    props: {
        variations: {
            type: Array,
            required: false,
            default() {
                return this.$parent.$refs.brick?.variations;
            },
        },

        value: {
            type: String,
            required: false,
        },

        required: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            loaded: false,
            options: this.variations,
            brick: null,
            selected: null,
        };
    },

    created() {
        Orbit.$on('global::brick:selected', this.newBrickSelected);
    },

    methods: {
        newBrickSelected(brick) {
            this.updateBrick(brick);
            this.updateVariations(brick?.variations)
        },

        updateBrick(brick) {
            this.brick = brick;
        },

        updateVariations(variations) {
            this.options = variations;

            if (this.loaded) {
                this.selected = null;
                return;
            }

            this.loaded = true;

            this.$nextTick(() => {
                this.selected = this.value;

                this.options.forEach((value, key) => {
                    value = `${value.height}x${value.length}x${value.depth}`;

                    if (value !== this.value) {
                        return;
                    }

                    this.selected = key;
                });

                this.$forceUpdate();
            });
        },
    },
}
</script>
